import type { Variants, Transition } from 'framer-motion'

// Easing tokens (DESIGN.md §6). Cubic-bezier tuples.
export const ease = {
  out: [0.16, 1, 0.3, 1],
  inOut: [0.65, 0, 0.35, 1],
  reticle: [0.85, 0, 0.15, 1],
  expo: [0.22, 1, 0.36, 1],
} as const

export const spring: Record<'stamp' | 'panel' | 'rail', Transition> = {
  stamp: { type: 'spring', stiffness: 420, damping: 26 },
  panel: { type: 'spring', stiffness: 220, damping: 26 },
  rail: { type: 'spring', stiffness: 200, damping: 26 },
}

// Shared scroll-reveal variants — finite, stagger 80ms, y:24→0.
export const revealParent: Variants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08 } },
}
export const revealChild: Variants = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: ease.out as unknown as number[] } },
}
